import { yupResolver } from '@hookform/resolvers/yup';
import { Button, Modal, Spin } from 'antd';
import { FormProvider, useForm } from 'react-hook-form';

import { useCreateFAQMutation } from '@/api/endpoints/mainPages';
import { DataSection, InputField } from '@/shared/components';
import { useApiRequest } from '@/shared/hooks';

import { FAQ_VALIDATION_SCHEMA } from '../../consts';
import type { IFormData } from '../../types';

import styles from './FAQModals.module.scss';

type TProps = {
  pageId: number;
  isModalOpen: boolean;
  handleCancel: VoidFunction;
};

export const CreateFAQModal = ({ pageId, isModalOpen, handleCancel }: TProps) => {
  const [createFAQ, { isLoading: isFAQCreating }] = useCreateFAQMutation();

  const sendApiRequest = useApiRequest();

  const methods = useForm<IFormData>({
    defaultValues: {
      question: '',
      answer: '',
    },
    resolver: yupResolver(FAQ_VALIDATION_SCHEMA),
  });

  const { handleSubmit } = methods;

  const handleCreateFAQ = handleSubmit(({ question, answer }) => {
    sendApiRequest({
      successMessage: 'Вопрос успешно создан',
      apiRequestCallback: () =>
        createFAQ({
          id: pageId,
          data: {
            question,
            answer,
          },
        }),
      successCallback: handleCancel,
    });
  });

  return (
    <Modal
      width={600}
      open={isModalOpen}
      onCancel={handleCancel}
      footer={null}
      centered
    >
      <Spin spinning={isFAQCreating}>
        <div className={styles.wrapper}>
          <FormProvider {...methods}>
            <p className={styles.title}>Добавление вопроса</p>
            <div className={styles['content-wrapper']}>
              <DataSection
                titleText="Текст вопроса"
                isTitleRequired
              >
                <InputField
                  fieldName="question"
                  placeholder="Текст"
                  shouldEnableLengthCounter
                  maxLengthCount={200}
                />
              </DataSection>
              <DataSection
                titleText="Ответ на вопрос"
                isTitleRequired
              >
                <InputField
                  fieldName="answer"
                  placeholder="Текст"
                  shouldEnableLengthCounter
                  maxLengthCount={500}
                />
              </DataSection>
            </div>
            <div className={styles['buttons-wrapper']}>
              <Button
                size="large"
                onClick={handleCancel}
                className={styles.button}
                danger
              >
                Отмена
              </Button>
              <Button
                size="large"
                onClick={handleCreateFAQ}
                type="primary"
                className={styles.button}
                disabled={isFAQCreating}
              >
                Сохранить
              </Button>
            </div>
          </FormProvider>
        </div>
      </Spin>
    </Modal>
  );
};
